import { Router } from '@angular/router';
import { GlobalServices } from 'src/app/global.services';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(
    private globalService: GlobalServices,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.globalService.logout()
    this.router.navigate(['/'])
  }

}
